import type { ReactElement } from 'react';

import { formatTimeSec, type VideoChapter } from '@/entities/video';

/**
 * 우측 스티키 목차.
 *
 * 영상 해설은 길어지므로 지금 어디를 보는지와 남은 구간을 항상 띄워 둔다.
 * 좁은 화면에서는 본문 위로 접어 올린다 — 사이드바를 감추면 이동 수단이 통째로 사라진다.
 *
 * **고정(sticky)은 여기가 아니라 사이드 전체에 건다.** 목차만 고정하면 스크롤할 때
 * 아래 형제 블록 위로 미끄러져 글자가 겹친다.
 */
export function ChapterNav({ chapters }: { chapters: readonly VideoChapter[] }): ReactElement {
  return (
    <nav aria-label="구간 목차">
      <p className="mb-3 font-mono text-[10px] text-muted-foreground uppercase tracking-[0.12em]">
        구간
      </p>
      <ol className="flex flex-col gap-1">
        {chapters.map((chapter, index) => (
          <li key={chapter.id}>
            <a
              href={`#${chapter.id}`}
              className="flex gap-2.5 rounded-md px-2 py-1.5 text-[13px] text-muted-foreground hover:bg-secondary hover:text-foreground"
            >
              <span data-numeric="" className="w-4 shrink-0 font-mono text-[11px] leading-[1.6]">
                {index + 1}
              </span>
              <span className="min-w-0 flex-1 leading-[1.6]">{chapter.title}</span>
              <span data-numeric="" className="shrink-0 font-mono text-[11px] leading-[1.6]">
                {formatTimeSec(chapter.timeSec)}
              </span>
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
